import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router'

const Catalog = lazy(() => import('pages/platform/course/Catalog'))
const Study = lazy(() => import('pages/platform/course/Study'))

const ActivityRoute = ({ match }) => {
  const rootUrl = match.url
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route exact path={`${rootUrl}/catalog`} component={(Catalog)} />
        <Route exact path={`${rootUrl}/study`} component={(Study)} />
      </Switch>
    </Suspense>
  )
}
export default ActivityRoute
